import { Segment } from './Segment.js';
export class SegmentIDs {
    /**
 *
 *
 *
 *
 */
    static ID_TO_KEY = [
        Segment.CORE,
        Segment.VENDORS_DISCLOSED,
        Segment.VENDORS_ALLOWED,
        Segment.PUBLISHER_TC,
    ];
    static KEY_TO_ID = {
        [Segment.CORE]: 0,
        [Segment.VENDORS_DISCLOSED]: 1,
        [Segment.VENDORS_ALLOWED]: 2,
        [Segment.PUBLISHER_TC]: 3,
    };
}
